import React, { createContext, useContext, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const { t } = useTranslation();
  const [state, setState] = useState(null);

  const confirm = useCallback(({ title, message, confirmText, cancelText, danger = true }) => {
    return new Promise((resolve) => {
      setState({ title, message, confirmText, cancelText, danger, resolve });
    });
  }, []);

  const handle = (ok) => {
    if (state?.resolve) state.resolve(ok);
    setState(null);
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      {state && (
        <div className="dialog-overlay" onClick={() => handle(false)}>
          <div className="dialog-panel" style={{ maxWidth: 440 }} onClick={(e) => e.stopPropagation()} data-testid="confirm-dialog">
            <h2 className="dialog-title">{state.title || t("confirm.title")}</h2>
            <p style={{ color: "#34322d", marginBottom: "1.4rem", whiteSpace: "pre-wrap" }}>{state.message}</p>
            <div className="flex justify-end gap-3">
              <button className="btn-outline-gold" onClick={() => handle(false)} data-testid="confirm-cancel-btn">
                {state.cancelText || t("confirm.defaultNo")}
              </button>
              <button
                className={state.danger ? "btn-danger" : "btn-primary-gold"}
                onClick={() => handle(true)}
                data-testid="confirm-ok-btn"
                autoFocus
              >
                {state.confirmText || t("confirm.defaultYes")}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error("useConfirm must be used within ConfirmProvider");
  return ctx.confirm;
};
